<div class="toast-content" fxLayout="column">
  <div class="header" fxLayout="row">
    <div class="title">{{ title }}</div>
    <div class="icon">
      <mat-icon>check_circle_outline</mat-icon>
    </div>
  </div>
  <div class="content">
    {{ subtitle }}
  </div>
</div>
